import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useTheme } from "@emotion/react";
import { useAudioCaptureWaveform } from "./audio-capture-wave-form.hooks";
import { Uuid } from "@/domains/global/identifiers";

export const AudioCaptureWaveForm = observer(
  ({
    associatedNoteId,
    isErrorState,
  }: {
    associatedNoteId?: Uuid | null;
    isErrorState?: boolean;
  }) => {
    const theme = useTheme();
    const barColor = isErrorState ? theme.colors.icon.secondary : theme.colors.icon.emphasis;
    const { waveFormBarHeights } = useAudioCaptureWaveform({ associatedNoteId });

    return (
      <WaveFormContainer>
        {waveFormBarHeights?.map((height, index) => (
          <WaveFormBar
            key={index}
            style={{ height: `${height * 100}%`, backgroundColor: barColor }}
          />
        ))}
        {!waveFormBarHeights && (
          <>
            <WaveFormBar style={{ height: `32%`, backgroundColor: barColor }} />
            <WaveFormBar style={{ height: `32%`, backgroundColor: barColor }} />
            <WaveFormBar style={{ height: `32%`, backgroundColor: barColor }} />
          </>
        )}
      </WaveFormContainer>
    );
  }
);

const WaveFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 1px;
  width: 16px;
  height: 16px;
  gap: 1px;
`;

const WaveFormBar = styled.div`
  width: 4px;
  transition: height 0.1s ease-in-out;
  border-radius: ${({ theme }) => theme.borderRadius.small};
`;
